import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import InsertData from "./InsertCompanyUnit";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { deleteAlert, errorAlert, updateAlert } from "../../Components/Alerts";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
// import { AiFillEdit, AiOutlineDelete, AiOutlineEdit, AiOutlinePrinter, AiOutlineFilePdf } from "react-icons/ai";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Paper } from "@mui/material";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import LoginUserDetailed from '../../Auth/LoginUserDetailed';
import { BsBank } from "react-icons/bs"
import jwtDecode from "jwt-decode";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";

export default function CompanyUnit() {
    const headers = authHeader();
    const loginEmail = LoginUserDetailed();

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [city, setCity] = useState([]);
    let number = 1;
    const [logedEmail, setLogedEmail] = useState("");
    const [role, setRole] = useState("");


    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const decodedToken = jwtDecode(token);
            setLogedEmail(decodedToken.email);
        }
    }, []);


    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        UnitID: "",
        UnitName: "",
        IdentificationNumber: "",
        UnitAdress: "",
        CityID: "",
        PhoneNumbers: "",
        Email: "",
        Comment: "",
        ModifiedByUser: "",
        IsActive: "",
    })


    // const fetchData = async () => {
    //     try {
    //         const response = await axios.get(ApiLink.API_URL + 'CompanyUnits', { headers, params: { email: logedEmail } });
    //         setData(response.data);
    //         setLoading(false);
    //     } catch (error) {
    //         if (error.response && error.response.data && error.response.data.errorMessage) {
    //             console.log("Gabim në marrjen e të dhënave:", error.response.data.errorMessage);
    //         } else {
    //             // errorAlert("Gabim në marrjen e të dhënave!");
    //         }
    //     }
    // };

    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'CompanyUnits', { headers });
            setData(response.data);
            setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);

            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    //Kodi per shfaqjen e tabeles ne PDF
    // const handleExportPDF = () => {
    //     const doc = new jsPDF();
    //     // Teksti i parë në fillim të dokumentit
    //     const text1 = "AccounTree";
    //     doc.text(text1, 10, 10); // 20 është pozicioni X, 10 është pozicioni Y

    //     // Teksti i dytë në fillim të dokumentit
    //     const text2 = "Company Unit List";
    //     doc.text(text2, 10, 20); // 20 është pozicioni X, 20 është pozicioni Y

    //     // Teksti i tretë në fillim të dokumentit
    //     // const text3 = "Accounting is the process of recording financial transactions pertaining to a business.";
    //     // doc.text(text3, 10, 30); // 20 është pozicioni X, 30 është pozicioni Y

    //     // Paragrafi në fillim të dokumentit
    //     // const paragraph = "Ky është një paragraf në fillim të tabelës.";
    //     // doc.text(paragraph, 20, 40); // 20 është pozicioni X, 40 është pozicioni Y
    //     doc.autoTable({
    //         head: [["Unit Name", "Identification Number", "Unit Adress", "Email"]],
    //         body: filteredData.map((item) => [item.UnitName, item.IdentificationNumber, item.UnitAdress, item.Email]),
    //         startY: 30
    //     });
    //     doc.save("CompanyUnits-List.pdf");
    // };
    //Kodi per shfaqjen e tabeles ne Print
    const tableRef = useRef();

    // const handlePrintTable = () => {
    //     const table = tableRef.current;
    //     const tableClone = table.cloneNode(true);
    //     const printWindow = window.open('', 'PrintWindow', 'height=400,width=600');
    //     printWindow.document.write(tableClone.outerHTML);
    //     printWindow.document.close();
    //     printWindow.focus();
    //     printWindow.print();
    //     printWindow.close();
    // };

    //Kodi per pegination ne tabel
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    //Kodi per dizajnin e tabeles
    const styles = {
        tableHeader: {
            backgroundColor: '#284945',
            color: 'white',

        },
        tableCell: {
            paddingTop: '1px',
            paddingBottom: '1px',

        },

    };
    //Kodi per shfaqjen e loadingut 
    const [loading, setLoading] = useState(true);


    const filteredData = data.filter((item) => {
        return (
            item.UnitName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.IdentificationNumber.includes(searchTerm)
        );
    });

    const handleDelete = async () => {
        try {
            const response = await axios.delete(
                ApiLink.API_URL + 'CompanyUnits' + `/${deleteItemId}`, { headers }
            );
            setShowDeleteConfirmation(false);
            deleteAlert("Unit Deleted Successfully");
            fetchData();
        } catch (error) {
            deleteAlert("Unit can not be deleted");
        }
    };

    //Kodi per shfaqjen e formes per editimin e te dhenave ne databaz 
    // const handleEdit = (item) => {
    //     setFormData({
    //         UnitID: item.UnitID,
    //         UnitName: item.UnitName,
    //         IdentificationNumber: item.IdentificationNumber,
    //         UnitAdress: item.UnitAdress,
    //         CityID: item.CityID,
    //         PhoneNumbers: item.PhoneNumbers,
    //         Email: item.Email,
    //         Comment: item.Comment,
    //         ModifiedByUser: loginEmail,
    //         IsActive: item.IsActive,
    //     });
    //     setShowEditModal(true);
    // };

    // Kodi per ruajtjen e te dhenave pas editimint 
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };
    //Dergimi i kerkeses per editimin e te dhenave ne backend 
    const handleSubmit = (event) => {
        event.preventDefault();
        const headers = authHeader();
        axios
            .put(ApiLink.API_URL + 'CompanyUnits', formData, { headers })
            .then((response) => {
                setShowEditModal(false); // Close the edit modal
                fetchData();
                updateAlert("Unit updated successfully");
            })
            .catch((error) => {
                // alert("Failed to update State");
                errorAlert("Failed to update Unit")
            });
    };

    const fetchRole = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'AuthProva/getrole', { headers });

            if (response.data.UserRole && response.data.UserRole !== undefined) {
                setRole(response.data.UserRole);
            } else {
                errorAlert("Undefined Role.");
            }
        } catch (error) {
            console.error("Error fetching role:", error);
            // ... (pjesa tjetër e kodit)
        }
    };

    useEffect(() => {
        axios.get(ApiLink.API_URL + 'cities', { headers })
            .then((response) => {
                setCity(response.data);
            }).catch((error) => {
                errorAlert(error);
            });
    }, []);


    useEffect(() => {
        fetchData();
        fetchRole();
    }, [logedEmail]);

    return (
        <div>
            {/* Modal per konfirmin nese deshiron me fshi nje element */}
            <Modal show={showDeleteConfirmation} onHide={() => setShowDeleteConfirmation(false)} style={{ marginTop: "150px" }}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete Unit?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Shfaqja  e modalit per editimin e te dhenave  */}
            {showEditModal && (
                <div className="edit-modal">
                    <form onSubmit={handleSubmit}>
                        <h3>Edit Unit</h3>

                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">ID </span>
                            <input
                                className="form-control"
                                type="number"
                                id="UnitID"
                                name="UnitID"
                                value={formData.UnitID}
                                onChange={handleInputChange}
                                disabled
                            />

                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Unit Name</span>
                            <input
                                className="form-control"
                                type="text"
                                id="UnitName"
                                name="UnitName"
                                value={formData.UnitName}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Identification Number</span>
                            <input
                                className="form-control"
                                type="number"
                                id="IdentificationNumber"
                                name="IdentificationNumber"
                                value={formData.IdentificationNumber}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Unit Adress</span>
                            <input
                                className="form-control"
                                type="text"
                                id="UnitAdress"
                                name="UnitAdress"
                                value={formData.UnitAdress}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <label className="input-group-text col-5 col-sm-5" htmlFor="stateSelect">City </label>
                            <select
                                id="CityID"
                                name="CityID"
                                className="form-control"
                                value={formData.CityID}
                                onChange={handleInputChange}
                            >
                                <option value="">-- Select state --</option>
                                {city.map((cities) => (
                                    <option key={cities.CityID} value={cities.CityID}>
                                        {cities.CityName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Phone Number</span>
                            <input
                                className="form-control"
                                type="text"
                                id="PhoneNumbers"
                                name="PhoneNumbers"
                                value={formData.PhoneNumbers}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Email</span>
                            <input
                                className="form-control"
                                type="text"
                                id="Email"
                                name="Email"
                                value={formData.Email}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text col-5 col-sm-5">Comment</span>
                            <textarea
                                className="form-control"
                                id="Comment"
                                name="Comment"
                                value={formData.Comment}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="IsActive">Active</label>
                            <input
                                type="checkbox"
                                id="IsActive"
                                name="IsActive"
                                checked={formData.IsActive}
                                onChange={(event) =>
                                    setFormData({ ...formData, IsActive: event.target.checked })
                                }
                            />
                        </div>
                        <button type="submit" className="btn btn-success">Update</button>

                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowEditModal(false)}
                        >
                            Cancel
                        </button>
                    </form>
                </div>
            )}
            <div className="header_flexx">
                {/* <div className="header_icon">
                    <BsBank style={{}} className="header_icons" />
                    <h3>Lista e Njesive Organizative</h3>
                </div> */}
                <TitleElements
                    icon={BsBank}
                    title="Lista e Njesive Organizative"
                />
                {
                    role === "acctree" && (
                        <div>
                            <InsertData fetchData={fetchData} />
                        </div>
                    )
                }
            </div>
            {/* <div className="header_paragraph">
                <p>Forma e Njesive Organizative: Menaxhoni, editoni të dhënat e kompanisë sipas kërkeses.</p>
            </div> */}
            <ElementsParagraph text="Forma e Njesive Organizative: Menaxhoni, editoni të dhënat e kompanisë sipas kërkeses." />


            <div className="bordere">
                <div className="butonss">
                    {/* <div>
                        <button className="button-15" onClick={handleExportPDF} variant="contained"><AiOutlineFilePdf /> PDF </button>
                    </div>
                    <div className="butons15">
                        <button className="button-15" variant="contained" onClick={handlePrintTable}><AiOutlinePrinter /> Print</button>
                    </div> */}
                </div>

                <div className="searchboxx">
                    <div className="flexbox">
                        <div class="search">
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search Company Units"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}

                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <hr></hr>
            <Paper>
                <TableContainer sx={{ maxHeight: 500 }}>
                    <Table ref={tableRef} stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={styles.tableHeader}><strong>#</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Unit Name</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Identification Number</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Unit Adress</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Email</strong></TableCell>
                                <TableCell sx={styles.tableHeader}><strong>Actions</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        {loading ? (
                            <div className="spinner" style={{ marginLeft: "560px" }} ></div>
                        ) : (
                            <TableBody>
                                {filteredData
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((item, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={item.UnitID}>
                                            <TableCell sx={styles.tableCell}>{number + index}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.UnitName}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.IdentificationNumber}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.UnitAdress}</TableCell>
                                            <TableCell sx={styles.tableCell}>{item.Email}</TableCell>
                                            <TableCell sx={styles.tableCell}>
                                                <Tooltip title="Delete" placement="right">
                                                    <IconButton
                                                        onClick={() => {
                                                            setShowDeleteConfirmation(true);
                                                            setDeleteItemId(item.UnitID);
                                                        }}
                                                    >
                                                        <DeleteIcon style={{ color: '#962a38' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>

                        )}
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}